// extracted by mini-css-extract-plugin
export default {"inlineAdWrapper":"iS-z","inlineTitle":"jS-z","sponsoredAdsWrapper":"kS-z","marketplaceRecosWrapper":"lS-z"};